import { useAppStore } from "@/store";

export async function generateCohereCompletion(
  messages: any[],
  model: string,
  config?: any
) {
  const { cohereKey } = useAppStore.getState();

  const res = await fetch(
    "https://gwqcbdekkxahyotegprp.supabase.co/functions/v1/cohere-proxy",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        messages,
        model,
        config,
        apiKey: cohereKey,
      }),
    }
  );

  if (!res.ok) {
    const errorData = await res.json();
    throw new Error(errorData.error || "Cohere API request failed");
  }

  const data = await res.json();
  return data;
}